import {
  HbrOption,
  HbrSelect
} from '@harbor/elements-react-standalone';
import React, { useState } from 'react';
import { useAddItemMutation, useFetchItems } from '../../../hooks/base-hooks';
import { CacheKey } from '../../../types/cache-keys';
import { asSingleValue } from '../../../support/utils';

const ImageUploadSelectControl = ({
  listImagesUrl,
  uploadImageUrl,
  selectedImage,
  selectImage,
  disabled = false,
}: {
  listImagesUrl: string;
  uploadImageUrl: string;
  selectedImage: string;
  selectImage: (fileName: string) => void;
  disabled?: boolean;
}) => {
  const [file, setFile] = useState<{ name: string; state: string }>();
  const [svgString, setSvgString] = useState('');
  // cache key: add as component param if used outside product icons
  const { data: availableItems, isLoading: isLoadingItems } = useFetchItems(
    listImagesUrl,
    CacheKey.ProductIcon
  );

  const uploadFile = useAddItemMutation('db/svg-icon', () => [
    CacheKey.ProductIcon,
  ]);

  // Disabled: updload svg functionality requires specific cleanup
  const onHbrSelect = async (event) => {
    const data = event.target && event.target.files && event.target.files[0];
    const maxSize = 100000; // Current icons are 2-4kb. This allows < 100kb
    if (maxSize < data.size) {
      data.state = 'error';
      data.message = 'File size limit exceeded';
    } else {
      data.state = 'done';
    }
    setFile(data);
    if (data && data.type === 'image/svg+xml') {
      const reader = new FileReader();
      reader.onload = (e: { target: { result: any } }) => {
        /**  need to strip some elements for this to save to db and then render as icons
         * escaped strings
         * styles that include inner quotes
         * initial xml definition before <svg />
         * \n and \t
         */
        setSvgString(e.target.result);
      };
      await reader.readAsText(data);
    }
  };

  const handleUpload = async () => {
    if (file) {
      const payload = {
        title: file.name,
        content: svgString,
      };
      const result = await uploadFile.mutateAsync(payload);
    }
  };

  return (
    <>
      <HbrSelect
        value={selectedImage || null}
        onHbr-change={(e) => selectImage(asSingleValue(e.target.value))}
        placeholder='Select a product icon'
        disabled={disabled || isLoadingItems}
      >
        {(availableItems ?? []).map((item) => (
          <HbrOption key={item.id} value={item.id}>
            <div className='flex items-center gap-2'>
              <img
                className='h-8 w-8'
                src={`data:image/svg+xml;utf8,${item.content}`}
              />
              <span>{item.title.substring(item.title)}</span>
            </div>
          </HbrOption>
        ))}
      </HbrSelect>
    </>
  );
};

export default ImageUploadSelectControl;
